/** Vite `base` with trailing slash stripped (`""` locally, `"/admin"` in the API image). */
export function adminBasePath(): string {
	return import.meta.env.BASE_URL.replace(/\/$/, "");
}

export function withAdminBase(path: string): string {
	const base = adminBasePath();
	const normalized = path.startsWith("/") ? path : `/${path}`;
	return `${base}${normalized}`;
}
